module.exports = __webpack_public_path__ + "img/comment-active.a3adac6f.svg";